/**
 * Calculates the loan duration in months based on the provided duration object.
 *
 * @param duration An object containing the loan amount and unit ('days', 'months', or 'years').
 * @returns The loan duration in months.
 */
export const getDurationInMonths = (duration: {
    amount: number;
    unit: 'days' | 'months' | 'years';
}): number => {
    const { amount, unit } = duration!;
    if (unit === 'days') {
        return getMonthsfromDays(amount);
    }
    if (unit === 'years') {
        return amount * 12;
    }
    return amount;
};
/**
 * Converts a number of days into an approximate number of months.
 *
 * @param days The number of days to convert.
 * @returns The approximate number of months.
 */
const getMonthsfromDays = (days: number): number => {
    return Math.floor(days / 30);
};
